module.exports = __webpack_public_path__ + "img/POP-00010-3.d6ed0d40.png";